import { render, staticRenderFns } from "./ReviewModal.vue?vue&type=template&id=fd7e4cec&scoped=true&"
import script from "./ReviewModal.vue?vue&type=script&lang=js&"
export * from "./ReviewModal.vue?vue&type=script&lang=js&"
import style0 from "./ReviewModal.vue?vue&type=style&index=0&id=fd7e4cec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7e4cec",
  null
  
)

export default component.exports